import React from 'react';
import {
  diabetes_management,
  bp_management,
  pregnancyIMG,
  weightmanagement,
  healthcoach,
} from '../../../../assets/images';
import { MetricCard } from '../../atoms';
import { commaingNumber } from '../../../../utils';

const HealthCoachPrograms = ({ metricObj, medicalObj, loading }) => {
  const { total_enrollment, ongoing_enrollment } = metricObj;
  const { bp, care_management, diabetes, non_sponsored_pregnancy, weight, sponsored_pregnancy } = medicalObj;

  return (
    <div>
      <p className='mt-8 text-xs font-semibold uppercase tracking-wider text-gray-500'>Enrollment</p>
      <div className='mt-4 grid grid-cols-1 gap-5 sm:grid-cols-2'>
        <MetricCard
          variant='ds-default'
          hideMetricIcon
          loading={loading}
          loaderHeight={120}
          svgsrc={healthcoach}
          title='Total Enrollments'
          metricValue={commaingNumber(total_enrollment)}
          metricValueSuffix='(Employees + Dependents)'
          classes='min-w-0 flex-1'
        />

        <MetricCard
          variant='ds-default'
          hideMetricIcon
          loading={loading}
          loaderHeight={120}
          svgsrc={healthcoach}
          title='Ongoing Enrollments'
          metricValue={commaingNumber(ongoing_enrollment)}
          metricValueSuffix='(Employees + Dependents)'
          classes='min-w-0 flex-1'
        />
      </div>
      <p className='text-sm text-gray-500 mt-2 mb-0 italic leading-none'>
        Total & ongoing enrollments include sponsored and self paid programs
      </p>

      {(!!care_management || !!sponsored_pregnancy || loading) && (
        <p className='mt-12 text-xs font-semibold uppercase tracking-wider text-gray-500'>Sponsored programs</p>
      )}
      <div className='mt-4 grid grid-cols-1 gap-5 sm:grid-cols-2'>
        {(!!care_management || loading) && (
          <MetricCard
            variant='ds-default'
            hideMetricIcon
            loading={loading}
            loaderHeight={120}
            svgsrc={weightmanagement}
            title='Care Management Program'
            metricValue={commaingNumber(care_management)}
            metricValueSuffix='(Employees + Dependents)'
            classes='min-w-0 flex-1'
          />
        )}

        {(!!sponsored_pregnancy || loading) && (
          <MetricCard
            variant='ds-default'
            hideMetricIcon
            loading={loading}
            loaderHeight={120}
            svgsrc={pregnancyIMG}
            title='Pregnancy Care Program'
            metricValue={commaingNumber(sponsored_pregnancy)}
            metricValueSuffix='(Employees / Dependents)'
            classes='min-w-0 flex-1'
          />
        )}
      </div>

      <p className='mt-12 text-xs font-semibold uppercase tracking-wider text-gray-500'>
        Self paid Health Coach Programs
      </p>
      <div className='mt-4 grid grid-cols-1 gap-5 sm:grid-cols-2 xl:grid-cols-4'>
        <MetricCard
          variant='ds-default'
          hideMetricIcon
          loading={loading}
          loaderHeight={120}
          svgsrc={weightmanagement}
          title='Weight Management Program '
          metricValue={commaingNumber(weight)}
          metricValueSuffix='(Employees + Dependents)'
          classes='min-w-0 flex-1'
        />

        <MetricCard
          variant='ds-default'
          hideMetricIcon
          loading={loading}
          loaderHeight={120}
          svgsrc={bp_management}
          title='Blood Pressure Management'
          metricValue={commaingNumber(bp)}
          metricValueSuffix='(Employees + Dependents)'
          classes='min-w-0 flex-1'
        />

        <MetricCard
          variant='ds-default'
          hideMetricIcon
          loading={loading}
          loaderHeight={120}
          svgsrc={diabetes_management}
          title='Diabetes Management Program'
          metricValue={commaingNumber(diabetes)}
          metricValueSuffix='(Employees + Dependents)'
          classes='min-w-0 flex-1'
        />

        <MetricCard
          variant='ds-default'
          hideMetricIcon
          loading={loading}
          loaderHeight={120}
          svgsrc={pregnancyIMG}
          title='Pregnancy Care Program'
          metricValue={commaingNumber(non_sponsored_pregnancy)}
          metricValueSuffix='(Employees + Dependents)'
          classes='min-w-0 flex-1'
        />
      </div>
    </div>
  );
};

export default HealthCoachPrograms;
